var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home" }, [
    _c("div", { staticClass: "contain" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("您好，" + _vm._s(_vm.userInfo.username)),
      ]),
      _c("div", { staticClass: "desc" }, [
        _vm._v(_vm._s(_vm.environment) + "：欢迎使用智能家居云平台"),
      ]),
      _vm.rolesCode
        ? _c(
            "div",
            [
              _vm.rolesCode !== "ROLE_ADMIN" &&
              _vm.rolesCode !== "PLATFORM_ADMIN"
                ? _c(
                    "el-button",
                    { attrs: { type: "linear" }, on: { click: _vm.jumpTo } },
                    [_vm._v("进入产品开发")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }